import React, { useState, useCallback } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import ButtonHeaderSubMenu from './ButtonHeaderSubMenu';
import { dataRoutes } from '../../routes/dataRoutes';
import './stylesHeader.scss';

function ViewHeader({ isLevelGroupActive, isApartmentActive }) {

    const [openMenuTitle, setOpenMenuTitle] = useState(null);

    const handleMenuToggle = useCallback((title) => {
        setOpenMenuTitle(prev => prev === title ? null : title);
    }, []);

    const handleMenuClose = useCallback(() => {
        setOpenMenuTitle(null);
    }, []);

    const getLinks = () => {

        const links = [];
        let currRoute;
        let currKeyIndex = 0;

        for (let i = 0; i < dataRoutes.length - 1; i++) {
            currRoute = dataRoutes[i];

            if (currRoute.title) { 
                links.push(
                    <li className='header--nav__li' key={ currKeyIndex }>
                        {
                        currRoute.routes === undefined
                        ? 
                        <NavLink 
                            className='header--nav__link main--menu__link-wrapper' 
                            activeClassName='header--nav__link-selected' 
                            to={ currRoute.path }
                            onClick={handleMenuClose}
                        >
                            <div className='main--menu__link'>
                                {currRoute.title }
                            </div>
                        </NavLink>
                        :
                        <ButtonHeaderSubMenu 
                            title={ currRoute.title } 
                            options={ currRoute.routes }
                            isOpen={ openMenuTitle === currRoute.title }
                            onToggle={ handleMenuToggle }
                            onClose={ handleMenuClose }
                        />
                        }
                    </li>
                );

                currKeyIndex++;
            }
        }

        return links;
    }

    const hidden = isLevelGroupActive || isApartmentActive;

    return (
        <header
            className='header'
            style={{
                opacity: hidden ? 0 : 1,
                pointerEvents: hidden ? 'none' : 'auto',
                transition: 'opacity 300ms ease',
            }}
        >
            <nav className='header--nav'>
                <ul className='header--nav-ui'>
                    <li className='header--nav__li'>
                        <NavLink className='header--nav__link-logo' to='/'>
                            <img src='./img/interface/logo--koya-small.png' width='250' height='auto' alt='Koya Logo' />
                        </NavLink>
                    </li>

                    { getLinks() }

                </ul>
            </nav>
        </header>
    );
}

const mapStateToProps = (state) => ({
    isLevelGroupActive: state.residences.isLevelGroupActive,
    isApartmentActive: state.residences.isApartmentActive,
});

export default connect(mapStateToProps)(ViewHeader);
